
import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

interface FAQItem {
  question: string;
  answer: string;
}

export const FAQSection = () => {
  const faqItems: FAQItem[] = [
    {
      question: "What kind of talent I can hire on Cutshort?",
      answer: "Cutshort specializes in tech talent, including software developers, data scientists, product managers, designers, QA engineers, DevOps specialists, and other technology roles. Our platform has 3.5M+ premium candidates with verified skills and experience in the tech industry."
    },
    {
      question: "How Cutshort compares with Naukri or LinkedIn or Instahyre?",
      answer: "Unlike general job platforms, Cutshort offers deep skill information for premium tech talent, AI-powered sourcing that reduces effort by 80%, and cost-effective pricing models. We provide intent data on candidates and focus exclusively on quality over quantity, resulting in faster hiring and higher candidate relevance."
    },
    {
      question: "What pricing models are supported?",
      answer: "Cutshort offers flexible pricing models, including a 'pay when you hire' option that can save up to 40% compared to traditional platforms. We also provide subscription-based models for companies with ongoing hiring needs and custom enterprise pricing for large-scale recruitment."
    },
    {
      question: "Does Cutshort integrate with my ATS?",
      answer: "Yes, Cutshort integrates with most popular Applicant Tracking Systems including Greenhouse, Lever, Workday, and more. We also offer API access for custom integrations with your internal systems."
    },
    {
      question: "What are the AI features Cutshort offers?",
      answer: "Cutshort's AI features include intelligent candidate matching, automated skill assessment, predictive hiring analytics, AI-powered job description optimization, and 24/7 AI recruiting agents that can screen and engage with candidates. These features work together to significantly reduce sourcing effort and improve hiring outcomes."
    },
    {
      question: "Is this driven by AI?",
      answer: "No, your roles are assigned to humans who supervise and monitor everything. Humans ensure that AI is used objectively and without biases. See our " + 
        '<a href="/responsible-ai" target="_blank" className="text-brand-blue hover:underline">Responsible AI statement</a>'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-darkgrey text-center mb-16">
            Frequently Asked Questions
          </h2>
          
          <Accordion type="single" collapsible className="w-full">
            {faqItems.map((item, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-lg font-medium text-brand-darkgrey px-6 py-4">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-4 text-brand-grey">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
